<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a>
              {{ $t("footer.contact") }}
            </a>
          </li>
          <br/>
          <li>
            +1(631)253 1166
          </li>
          <li class="li">
            +229 90 58 52 45
          </li>
          <li class="li">
            +90 533 867 84 03
          </li>
          <li class="li">
            +229 97 99 75 00
          </li>
          <li class="li">
            +228 99 35 03 64
          </li>
        </ul>
      </nav>
      <div class="copyright">
        <div>
          contact@grelianedagbedji.com
        </div>

        <div class="second">
          &copy; {{ year }}, made by <a href="https://web.facebook.com/tokBenin" target="_blank">TOK</a>.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.li {
  margin-left: 10px;
}
.second {
  margin-top: 20px;
}
</style>
